import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
  NgModule,
} from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
// Components
import { BreadcrumbComponent } from "./components/breadcrumb/breadcrumb.component";
import { FeatherIconsComponent } from "./components/feather-icons/feather-icons.component";
import { FooterComponent } from "./components/footer/footer.component";
import { HeaderComponent } from "./components/header/header.component";
import { ContentComponent } from "./components/layout/content/content.component";
import { FullComponent } from "./components/layout/full/full.component";
import { LoaderComponent } from "./components/loader/loader.component";
import { SidebarComponent } from "./components/sidebar/sidebar.component";
import { TapToTopComponent } from "./components/tap-to-top/tap-to-top.component";
// Header Elements Components
import { SearchComponent } from "./components/header/elements/search/search.component";
import { LanguagesComponent } from "./components/header/elements/languages/languages.component";
import { NotificationComponent } from "./components/header/elements/notification/notification.component";
import { BookmarkComponent } from "./components/header/elements/bookmark/bookmark.component";
import { CartComponent } from "./components/header/elements/cart/cart.component";
import { MessageBoxComponent } from "./components/header/elements/message-box/message-box.component";
import { MyAccountComponent } from "./components/header/elements/my-account/my-account.component";

// Services
import { LayoutService } from "./services/layout.service";
import { NavService } from "./services/nav.service";
import { DecimalPipe } from "@angular/common";
import { ConfirmationService } from "./services/confirmation.service";
import { LanguageHelperService } from "./services/language-helper.service";
import { SvgIconComponent } from "./components/svg-icon/svg-icon.component";
import { SwiperModule } from "swiper/angular";
import { SwiperComponent } from "./components/header/elements/swiper/swiper.component";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { SearchPipe } from "./pipe/search.pipe";
import { FilterPipe } from "./pipe/filter.pipe";
import { OnlyNumberDirective } from "src/app/shared/Directive/onlyNumber.directive";
// Library
import { AvatarModule } from "ngx-avatars";
import { TranslateModule } from "@ngx-translate/core";
import { DocumentsModule } from "../components/documents/documents.module";
import { MaxDateDirective } from "./Directive/maxDate.directive";
import { SortDirective } from "./Directive/sortable.directive";
import { LowerCaseToStringDirective } from "./Directive/lowerCaseToString.directive";
const avatarColors = ["#7265FD"];

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    ContentComponent,
    BreadcrumbComponent,
    FeatherIconsComponent,
    FullComponent,
    LoaderComponent,
    TapToTopComponent,
    SearchComponent,
    LanguagesComponent,
    NotificationComponent,
    BookmarkComponent,
    CartComponent,
    MessageBoxComponent,
    MyAccountComponent,
    SvgIconComponent,
    SwiperComponent,
    SearchPipe,
    FilterPipe,
    MaxDateDirective,
    LowerCaseToStringDirective,
    SortDirective,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    SwiperModule,
    AvatarModule.forRoot({ colors: avatarColors }),
    SweetAlert2Module.forRoot(),
    TranslateModule.forChild(),
  ],
  providers: [
    NavService,
    LayoutService,
    DecimalPipe,
    ConfirmationService,
    LanguageHelperService,
  ],
  exports: [
    NgbModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LoaderComponent,
    BreadcrumbComponent,
    FeatherIconsComponent,
    TapToTopComponent,
    SvgIconComponent,
    SwiperModule,
    SearchPipe,
    FilterPipe,
    AvatarModule,
    TranslateModule,
    MaxDateDirective,
    LowerCaseToStringDirective,
    SortDirective,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedModule {}
